<template>
  <div :class="['product-card', {loader : !product.articles}]">
    <template v-if="product.articles.length > 0">
      <a :href="productLink">
        <div class="card-image">
          <img 
            class="img image-front"
            :class="{'image-single': product.hover === undefined}"
            :src="getImage(product.path)"
            alt="product.png"
          />
          <img 
            v-if="product.hover"
            class="img image-back"
            :src="getImage(product.hover)"
            alt="product.png"
          />
        </div>
        <div class="card-footer">
          <div class="card-title">
            {{product.title}}
          </div>
          <div class="card-description" v-if="product.title_detail" v-html="product.title_detail"></div>
          <div class="card-description" v-if="search && articles">
            Артикул {{ articles }}
          </div>
          <div class="card-description" v-if="search && colors">
            Цвет {{ colors }}
          </div>
        </div>
        <div
          v-if="product.label_type && product.label"
          class="card-label"
          :class="{ 'liquid': product.label_type === 2 }"
        >
          {{product.label.toLowerCase()}}
        </div>
      </a>
    </template>
    <template v-else>
      <div class="load-skeleton" style="height: 418px"></div>
    </template>
  </div>
</template>

<script>
import utils from '@/utils';
import './product-card.sass';

export default {
  name: 'product-card',
  props: {
    product: null,
    search: null,
  },
  methods: {
    getImage(path) {
      const { getStaticImage } = utils()
      return getStaticImage(null, null, path)
    },
  },
  computed: {
    productLink() {
      if (this.product.articles[0].link === 'oil-product') {
        return `/oil-gigas-product?id=${this.product.id}`;
      }
      return `/catalog/${this.product.articles[0].link}`;
    },
    articles() {
      return this.product.articles.map((value) => { return value.code }).join(', ');
    },
    colors() {
      let article = this.product.articles.find((value) => {
        if (value.charact[0] && value.charact[0].colors) {
          return value.charact[0].colors.code.indexOf(this.search) >= 0
        }
      });
      if (article) {
        return article.charact[0].colors.title;
      }
      return null;
    }
  },
}
</script>